import { withStyles } from '@material-ui/core';
import { STOP_TYPE } from '../../../constants';
import ProNumber from './ProNumber';
import PickupNumber from './PickupNumber';

const styles = (theme) => ({
  negativeValue: { color: theme.violationsTextColor },
  highlightedValue: {
    color: theme.HeaderSelectedText
  },
  underline: {
    textDecoration: "underline",
    display: "inline-block",
    cursor: "pointer"
  }
});

const ProNumberValue = ({
  stopData,
  classes,
  highlighted,
  route,
  staticClientStatusLists,
  enableReturnExceptionReasonLabels
}) => {
  const classNames = (status, highlighted) => {
    if (status) {
      return classes.negativeValue;
    } else if (highlighted) {
      return classes.highlightedValue;
    } else {
      return '';
    }
  };
  if (stopData.stopType === STOP_TYPE.Pickup) {
    return (
      <PickupNumber
        stopData={stopData}
        route={route}
        classNames={classNames}
        highlighted={highlighted}
        classes={classes}
      />
    );
  } else {
    return (
      <ProNumber
        stopData={stopData}
        classNames={classNames}
        highlighted={highlighted}
        route={route}
        classes={classes}
        staticClientStatusLists={staticClientStatusLists}
        enableReturnExceptionReasonLabels={enableReturnExceptionReasonLabels}
      />
    );
  }
};

export default withStyles(styles)(ProNumberValue);
